import React, { FC, useContext } from 'react';
import { Formik, FormikProps } from 'formik';
import { Col, Modal, Row, Select } from 'antd';
import { AntForm } from '@core/ui';
import { FormAlert, SelectField, TextAreaField, DateField } from '@core/form';
import { Constants } from '@core/constants';

import { CreateInspectionContext } from '../contexts';
import { useCreateInspection } from '../hooks';
import { CreateInspectionDto } from '../dtos';
import { useBranches } from '@modules/branches';

const FormikComponent: FC<FormikProps<CreateInspectionDto>> = ({ status, handleSubmit, isSubmitting }) => {
  const { onCancel } = useContext(CreateInspectionContext);
  const branches = useBranches();

  return (
    <Modal width={600} visible={true} onOk={() => handleSubmit()} onCancel={onCancel} confirmLoading={isSubmitting} title='Yeni Filial Yoxlanışı' okText='Yarat' cancelText='Ləğv et'>
      <FormAlert $visible={!!status} message={status?.message} />
      <AntForm layout='vertical' component='div' size='large'>
        <Row gutter={[24, 0]}>
          <Col xs={24}>
            <SelectField
              name='branchId'
              item={{ label: 'Filial', required: true }}
              input={{
                placeholder: 'Filial seçin...',
                showSearch: true,
              }}
            >
              {branches.data?.map((branch) => (
                <Select.Option key={branch.id} value={branch.id.toString()}>
                  {branch.name}
                </Select.Option>
              ))}
            </SelectField>
          </Col>
          <Col xs={24}>
            <DateField name='deadline' item={{ label: 'Son tarix' }} input={{ placeholder: 'Son tarix seçin...', format: Constants.DATE_TIME, showTime: true }} />
          </Col>
          <Col xs={24}>
            <TextAreaField name='note' item={{ label: 'Qeyd' }} input={{ placeholder: 'Qeyd daxil edin...', rows: 4 }} />
          </Col>
        </Row>
      </AntForm>
    </Modal>
  );
};

export const CreateInspection: FC = () => {
  const { initialValues, onSubmit } = useCreateInspection();

  if (!initialValues) {
    return null;
  }

  return <Formik initialValues={initialValues} onSubmit={onSubmit} enableReinitialize={true} component={FormikComponent} />;
};
